<template>
  <div class="ma-4" id="client-summary">
    <ClientNav :clientState="clientState" class="hideOnPrint" />
    <v-layout row wrap class="hideOnPrint">
      <v-btn
        fab
        small
        @click="print()"
        class="mr-8 mb-6 white--text"
        color="#2b6993"
        elevation="4"
        right
        absolute
      >
        <v-icon>print</v-icon>
      </v-btn>
      <v-flex xs12 class="pa-3 mt-9">
        <!-- <v-card> -->
        <v-card-title class="success white--text">{{
          clientName
        }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-2">
          <v-row>
            <v-col cols="12" md="2">
              <v-img :src="image" height="250"></v-img>
            </v-col>
            <v-col cols="12" md="10">
              <v-row>
                <v-col cols="12" sm="6"> Client ID: {{ clientID }} </v-col>
                <v-col cols="12" sm="6">
                  Admission Date: {{ admissionDate | formattedDate }}
                </v-col>
                <v-col cols="12" sm="6">
                  Date of Birth: {{ birthday | formattedDate }}
                </v-col>
                <v-col cols="12" sm="6"> Age: {{ age }} </v-col>
                <v-col cols="12" sm="6"> Gender: {{ gender }} </v-col>
                <v-col cols="12" sm="6"> Ethnicity: {{ ethnicity }} </v-col>
                <v-col cols="12" sm="6"> Allergies: {{ allergies }} </v-col>
                <v-col cols="12" sm="6">
                  Current Programs: {{ program }}
                </v-col>
                <v-col cols="12" sm="6"> Medicare #: {{ medicare }} </v-col>
                <v-col cols="12" sm="6"> Medicaid #: {{ medicaid }} </v-col>
                <v-col cols="12" sm="6"> PID: {{ pid }} </v-col>
                <v-col cols="12" sm="6"> Case #: {{ caseNumber }} </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- </v-card> -->
      </v-flex>

      <v-flex xs12 class="pa-3">
        <v-card>
          <v-card-title class="success white--text"
            >Client Warnings</v-card-title
          >
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12">
                <v-list>
                  <v-list-item v-for="warning in warnings" :key="warning._id">
                    <v-list-item-title>{{
                      warning.Description
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 class="pa-3">
        <v-card>
          <v-card-title class="success white--text"
            >Active Diagnoses</v-card-title
          >
          <v-divider></v-divider>
          <v-card-text>
            <v-card-title>Medical Diagnoses</v-card-title>

            <v-col cols="12" sm="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Diagnosis</th>
                      <th class="text-left">Diagnosed By</th>
                      <th class="text-left">Start Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="diagnose in medical" :key="diagnose._id">
                      <td>{{ diagnose.Diagnosis }}</td>
                      <td>{{ diagnose.DiagnosedBy }}</td>
                      <td>{{ diagnose.StartDate }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>

            <v-card-title>Clinical Diagnoses</v-card-title>

            <v-col cols="12" sm="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Diagnosis</th>
                      <th class="text-left">Diagnosed By</th>
                      <th class="text-left">Start Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="diagnose in clinical" :key="diagnose._id">
                      <td>{{ diagnose.Diagnosis }}</td>
                      <td>{{ diagnose.DiagnosedBy }}</td>
                      <td>{{ diagnose.StartDate }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 class="pa-3">
        <v-card>
          <v-card-title class="success white--text"
            >Insurance Info</v-card-title
          >
          <v-divider></v-divider>
        </v-card>
      </v-flex>

      <v-flex xs12 class="pa-3">
        <v-card>
          <v-card-title class="success white--text"
            >Adaptive Equipment</v-card-title
          >
          <v-divider></v-divider>
          <v-card-text>
            <v-col cols="12" sm="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Date</th>
                      <th class="text-left">Adaptive Equipment</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="equip in equipment" :key="equip._id">
                      <td>{{ equip.StartDate }}</td>
                      <td>{{ equip.Equipment }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 class="pa-3">
        <v-card>
          <v-card-title class="success white--text"
            >Prescribed Medications</v-card-title
          >
          <v-divider></v-divider>
          <v-card-text>
            <v-col cols="12" sm="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Medication</th>
                      <th class="text-left">Med Class</th>
                      <th class="text-left">Prescribed By</th>
                      <th class="text-left">Physician Instructions</th>
                      <th class="text-left">Dosage</th>
                      <th class="text-left">Diagnosis</th>
                      <th class="text-left">Start Date</th>
                      <th class="text-left">RX</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="medication in medications" :key="medication._id">
                      <td>{{ medication.Medication }}</td>
                      <td>{{ medication.MedClass }}</td>
                      <td>{{ medication.PrescribedBy }}</td>
                      <td>{{ medication.Instructions }}</td>
                      <td width="20%">
                        {{ medication.FormattedDosage }} ({{
                          medication.AdminTime.join(", ")
                        }})
                      </td>
                      <td>{{ medication.Diagnosis }}</td>
                      <td width="10%">{{ medication.StartDate }}</td>
                      <td>{{ medication.RXNumber }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 class="pa-3">
        <v-card>
          <v-card-title class="success white--text"
            >Support Strategies</v-card-title
          >
          <v-divider></v-divider>
          <v-card-text>
            <v-col cols="12" sm="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Goal</th>
                      <th class="text-left">Purpose</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="support in supports" :key="support._id">
                      <td>{{ support.Goal }}</td>
                      <td>{{ support.Purpose }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 class="pa-3">
        <v-card>
          <v-card-title class="success white--text">Providers</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-col cols="12" sm="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Name</th>
                      <th class="text-left">Role</th>
                      <th class="text-left">Phone Number</th>
                      <th class="text-left">Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="provider in providers" :key="provider.Provider._id">
                      <td>{{ provider.Provider.Name }}</td>
                      <td>{{ provider.Provider.Profession }}</td>
                      <td>{{ provider.Provider.Phone }}</td>
                      <td>{{ provider.Provider.Email }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Print view -->

    <div id="printTable">
      <h2 class="text-center ma-2">Client Summary</h2>
      <v-layout row wrap>
        <v-flex xs12 class="pa-3 border">
          <!-- <v-card> -->
          <v-card-title class="success white--text">{{
            clientName
          }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-2">
            <v-row>
              <v-col cols="12" md="10">
                <v-row>
                  <v-col cols="12" sm="6"> Client ID: {{ clientID }} </v-col>
                  <v-col cols="12" sm="6">
                    Admission Date: {{ admissionDate }}
                  </v-col>
                  <v-col cols="12" sm="6">
                    Date of Birth: {{ birthday }}
                  </v-col>
                  <v-col cols="12" sm="6"> Age: {{ age }} </v-col>
                  <v-col cols="12" sm="6"> Gender: {{ gender }} </v-col>
                  <v-col cols="12" sm="6"> Ethnicity: {{ ethnicity }} </v-col>
                  <v-col cols="12" sm="6"> Allergies: {{ allergies }} </v-col>
                  <v-col cols="12" sm="6">
                    Current Programs: {{ program }}
                  </v-col>
                  <v-col cols="12" sm="6"> Medicare #: {{ medicare }} </v-col>
                  <v-col cols="12" sm="6"> Medicaid #: {{ medicaid }} </v-col>
                  <v-col cols="12" sm="6"> PID: {{ pid }} </v-col>
                  <v-col cols="12" sm="6"> Case #: {{ caseNumber }} </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <!-- </v-card> -->
        </v-flex>

        <v-flex xs12 class="pa-3 border">
          <!-- <v-card> -->
          <v-card-title class="success white--text"
            >Client Warnings</v-card-title
          >
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12">
                <v-list>
                  <v-list-item v-for="warning in warnings" :key="warning._id">
                    <v-list-item-title>{{
                      warning.Description
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-card-text>
          <!-- </v-card> -->
        </v-flex>

        <v-flex xs12 class="pa-3 border">
          <!-- <v-card> -->
          <v-card-title class="success white--text"
            >Active Diagnoses</v-card-title
          >
          <v-divider></v-divider>
          <v-card-text>
            <v-card-subtitle>Medical Diagnoses</v-card-subtitle>

            <v-col cols="12" sm="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Diagnosis</th>
                      <th class="text-left">Diagnosed By</th>
                      <th class="text-left">Start Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="diagnose in medical" :key="diagnose._id">
                      <td>{{ diagnose.Diagnosis }}</td>
                      <td>{{ diagnose.DiagnosedBy }}</td>
                      <td>{{ diagnose.StartDate }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>

            <v-card-subtitle>Clinical Diagnoses</v-card-subtitle>

            <v-col cols="12" sm="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Diagnosis</th>
                      <th class="text-left">Diagnosed By</th>
                      <th class="text-left">Start Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="diagnose in clinical" :key="diagnose._id">
                      <td>{{ diagnose.Diagnosis }}</td>
                      <td>{{ diagnose.DiagnosedBy }}</td>
                      <td>{{ diagnose.StartDate }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-card-text>
          <!-- </v-card> -->
        </v-flex>
        <!--
        <v-flex xs12 class="pa-3 border">
          <v-card-title class="success white--text"
            >Insurance Info</v-card-title
          >
          <v-divider></v-divider>
        </v-flex>
        -->

        <v-flex xs12 class="pa-3 border">
          <!-- <v-card> -->
          <v-card-title class="success white--text"
            >Adaptive Equipment</v-card-title
          >
          <v-divider></v-divider>
          <v-card-text>
            <v-col cols="12" sm="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Date</th>
                      <th class="text-left">Adaptive Equipment</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="equip in equipment" :key="equip._id">
                      <td>{{ equip.StartDate }}</td>
                      <td>{{ equip.Equipment }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-card-text>
          <!-- </v-card> -->
        </v-flex>

        <v-flex xs12 class="pa-3 border">
          <!-- <v-card> -->
          <v-card-title class="success white--text"
            >Prescribed Medications</v-card-title
          >
          <v-divider></v-divider>
          <v-card-text>
            <v-col cols="12" sm="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Medication</th>
                      <th class="text-left">Med Class</th>
                      <th class="text-left">Prescribed By</th>
                      <th class="text-left">Physician Instructions</th>
                      <th class="text-left">Dosage</th>
                      <th class="text-left">Start Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="medication in medications" :key="medication._id">
                      <td>{{ medication.Medication }}</td>
                      <td>{{ medication.MedClass }}</td>
                      <td>{{ medication.PrescribedBy }}</td>
                      <td>{{ medication.Instructions }}</td>
                      <td>
                        {{ medication.FormattedDosage }} {{ medication.AdminTime }}
                      </td>
                      <td>{{ medication.StartDate }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-card-text>
          <!-- </v-card> -->
        </v-flex>

        <v-flex xs12 class="pa-3 border">
          <!-- <v-card> -->
          <v-card-title class="success white--text"
            >Support Strategies</v-card-title
          >
          <v-divider></v-divider>
          <v-card-text>
            <v-col cols="12" sm="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Goal</th>
                      <th class="text-left">Purpose</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="support in supports" :key="support._id">
                      <td>{{ support.Goal }}</td>
                      <td>{{ support.Purpose }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-card-text>
          <!-- </v-card> -->
        </v-flex>

        <v-flex xs12 class="pa-3 border">
          <!-- <v-card> -->
          <v-card-title class="success white--text">Providers</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-col cols="12" sm="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Name</th>
                      <th class="text-left">Role</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="provider in providers" :key="provider._id">
                      <td>{{ provider.Name }}</td>
                      <td>{{ provider.Profession }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-card-text>
          <!-- </v-card> -->
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import ClientNav from "../../components/ClientNav";
import Swal from "sweetalert2";
import {calculateAge} from '../../../helpers/calculateAge'
import { mapActions } from "vuex";

const url = require("../../client_config/config").url;

export default {
  components: {
    ClientNav,
  },
  data: function () {
    return {
      warnings: [],
      providers: [],
      diagnoses: [],
      medications: [],
      supports: [],
      clinical: [],
      medical: [],
      equipment: [],
      clientID: "",
      image: "",
      clientState: "",
      clientName: "",
      admissionDate: "",
      allergies: "",
      bio: "",
      brithday: "",
      age: "",
      caseNumber: "",
      ethnicity: "",
      gender: "",
      medicaid: "",
      medicare: "",
      pid: "",
      program: [],
      wellsky: "",
      adaptiveDate: "",
      adaptiveEquipment: "",
      birthday: "",
    };
  },

  computed: {},

  created() {
    this.clientID = this.$route.params.clientID;
    this.getWarnings(this.clientID);
    this.getClient(this.clientID);
    this.getProviders();
    this.getMedication(this.clientID);
    this.getSupports(this.clientID);
    this.getDiagnoses(this.clientID);
    this.getEquipment(this.clientID);
  },

  methods: {

    ...mapActions({
      getClientProviders: "clientProviders/getItem",
    }),

    getWarnings(clientID) {
      axios.get(`${url}/warning/client/${clientID}`).then((res) => {
        this.warnings = [];
        this.warnings = res.data.warnings;
      });
    },

    /* deprecated methods
    getProviders(clientID) {
      this.isLoading = true;
      axios
        .get(`${url}/providers/clientProvider/${clientID}`)
        .then((res) => {
          this.providers = res.data.providers;
          console.log(this.providers);
        })
        .finally(() => (this.isLoading = false));
    },
    */

    async getProviders(){
      const response = await this.getClientProviders(this.clientID);
      this.providers = response.data;
    },

    getDiagnoses(clientID) {
      this.isLoading = true;
      this.diagnoses = [];
      axios
        .get(`${url}/diagnoses/client/${clientID}`)
        .then((res) => {
          this.diagnoses = res.data.diagnoses;

          for (var i = 0; i < this.diagnoses.length; i++) {
            if (this.diagnoses[i].DiagnosisType == "Clinical") {
              this.clinical.push(this.diagnoses[i]);
            }

            if (this.diagnoses[i].DiagnosisType == "Medical") {
              this.medical.push(this.diagnoses[i]);
            }
          }
        })
        .finally(() => (this.isLoading = false));
    },

    // getMedication: function() {
    // this.isLoading = true;
    // axios.get(`${url}/medications/all/${this.clientID}`).then((res) => {
    // this.medications = [];
    // this.discontinuedMedications = [];
    // this.tempData = res.data.medications;
    // for (var i = 0; i < this.tempData.length; i++) {
    //     if (
    //     this.tempData[i].IsActive === true
    //     ) {
    //     this.tempData[i].StartDate = moment(
    //         new Date(this.tempData[i].StartDate)
    //     ).format("MM-DD-YYYY LT");

    //     console.log(this.tempData[i].PrescribedBy.Name + " prescribed by")

    //     if(this.tempData[i].PrescribedBy.Name == undefined){
    //         continue
    //     }

    //     this.medications.push(this.tempData[i]);

    //     }

    //     if (
    //     this.tempData[i].IsActive === false
    //     ) {

    //     this.discontinuedMedications.push(this.tempData[i]);
    //     }

    // }
    // }).finally(() => (this.isLoading = false));
    // },
    async getMedication() {
      try {
        this.isLoading = true;

        const {
          data: { medications },
        } = await axios.get(`${url}/medications/all/${this.clientID}`);

        const activeMeds = medications.filter(
          (med) => med.IsActive
        );

        const updatedMeds = activeMeds.map(
          ({ StartDate, PrescribedBy, ...med }) => ({
            ...med,
            StartDate: moment(new Date(StartDate)).format("MM-DD-YYYY"),
            PrescribedBy: PrescribedBy?.Name,
            FormattedDosage: this.formatDosage(med)
          })
        );

        const updatedDiscontinuedMeds = medications.filter(
          (med) => !med.IsActive
        );

        this.medications = updatedMeds.sort((a, b) => {
          return a.Medication.localeCompare(b.Medication);
        });

        this.discontinuedMedications = updatedDiscontinuedMeds;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    getSupports(clientID) {
      this.isLoading = true;
      axios
        .get(`${url}/support/${clientID}`)
        .then((res) => {
          this.supports = [];
          this.disabled = [];
          this.tempData = res.data.supports;
          for (var k = 0; k < this.tempData.length; k++) {
            if (this.tempData[k].Active == "Active") {
              this.supports.push(this.tempData[k]);
            } else {
              this.disabled.push(this.tempData[k]);
            }
          }
          for (var i = 0; i < this.supports.length; i++) {
            // var dt = new Date(this.supports[i].ReviewDate);
            this.supports[i].ReviewDate = moment(
              this.supports[i].ReviewDate
            ).format("MM/DD/YYYY");
            // var bt = new Date(this.supports[i].StartDate);
            this.supports[i].StartDate = moment(
              this.supports[i].StartDate
            ).format("MM/DD/YYYY");
            // var ct = new Date(this.supports[i].EndDate);
            this.supports[i].EndDate = moment(this.supports[i].EndDate).format(
              "MM/DD/YYYY"
            );
          }
        })
        .finally(() => (this.isLoading = false));
    },

    getClient(clientID) {
      axios.get(`${url}/clients/${clientID}`).then(async (res) => {
        const client = res.data.client[0]

        this.client = client;
        this.clientID = client._id;
        this.image = client.Image;
        this.clientState = client.State;
        this.clientName = client.Name;
        this.admissionDate = client.AdmissionDate;
        this.allergies = client.Allergies.map(item => item.Allergy).join(", ");
        this.bio = client.Bio;
        this.birthday = client.Birthday;
        this.age = client.Age;
        this.caseNumber = client.Case;
        this.ethnicity = client.Ethnicity;
        this.gender = client.Gender;
        this.medicaid = client.Medicaid;
        this.medicare = client.Medicare;
        this.pid = client.PID;
        this.program = client.Program.join(", ");
        this.wellsky = client.Wellsky;
        this.adaptiveDate = client.AdaptiveDate;
        this.adaptiveEquipment = client.EquipmentUsed;
        this.age = calculateAge(client.Birthday);
      });
    },

    getEquipment(clientID) {
      axios
        .get(`${url}/equipment/${clientID}`)
        .then((res) => {
          this.equipment = res.data.equipment;
        })
        .finally(() => (this.isLoading = false));
    },
    print() {
      Swal.fire({
        title: "Print in Progress",
        text: "Please wait while the PDF is being generated and processed. This may take a while if some images or files are attached.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      fetch(`${url}/clients/generate/pdf/${this.clientID}`)
        .then((response) => response.blob())
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob);
          const printWindow = window.open(blobUrl);

          printWindow.onload = function () {
            Swal.close();
            printWindow.print();
            URL.revokeObjectURL(blobUrl);
          };
        })
        .catch((error) => {
          console.error("Error generating or printing the PDF:", error);
          Swal.fire("Error", "Failed to generate or print the PDF", "error");
        });
    },
    formatDosage(med) {
      let dosage = 0;
      if (med.Dosage === "" || med.Dosage === undefined) return dosage;
      dosage = med.Dosage.replace(/,/g, "").split(/(\d+\.?\d*)/);
      let totalDosage = Math.round(dosage[1] * med.Quantity * 100) / 100;
      return this.formattedTotalDosage(totalDosage) + dosage[2];
    },

    formattedTotalDosage(num) {
      return String(num).replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, "$&,");
    },

  },
};
</script>
<style>
#client-summary tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

#printTable {
  display: none;
}

#printItem {
  display: none;
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media print {
  #printTable {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }
  #printItem {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }
  .hideOnPrint {
    display: none;
    border: none;
  }

  .border {
    border: 1px solid black;
    margin: 5px;
  }

  nav.v-navigation-drawer,
  header.v-toolbar,
  button.v-btn,
  div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }
  body {
    margin: 1.6cm;
  }
}
</style>
